<template>
    <div>
        <el-row v-if="!id" :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <!--<el-form-item prop="userId" label="用户:" :rules="[{required: true, message: '请输入用户名'}]">    
                    <el-input v-model.trim="formData.userId" type="number" size="medium" placeholder="请输入用户名检索">
                        <el-button slot="append" icon="el-icon-s-opportunity" @click="checkUserInfo" :loading="btnLoading">检测</el-button>
                    </el-input>
                </el-form-item>-->
				<el-form-item prop="userId" label="用户名:" :rules="[{required: true, message: '请输入用户名'}]">
				    <el-select 
				        v-model="formData.userId" 
				        filterable 
				        remote				        
				        placeholder="请输入用户名"
				        :remote-method="searchHost"
				        :loading="userLoading"
				        size="medium">
				        <el-option
				            v-for="item in hostList"
				            :key="item.id"
				            :label="`[${$userType.get(item.userType)}]${item.name}`"
				            :value="item.id">
				        </el-option>
				    </el-select>
				</el-form-item>
            </el-col>
           <!-- <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="name" label="用户身份/名称:" :rules="[{required: true, message: '请检测用户信息'}]">
                    <el-row :gutter="30">
                        <el-col :span="12"><span class="color-info">用户名称: </span>{{formData.name}}</el-col>
                        <el-col :span="12"><span class="color-info">用户身份:</span>{{$userType.get(formData.userType)}}</el-col>
                    </el-row>
                </el-form-item>
            </el-col>-->
        </el-row>
        <el-row v-else :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-card shadow="never" class="user-info">
                    <ul>
                        <li><span class="color-info">用户ID: </span>{{formData.userId}}</li>
                        <li><span class="color-info">用户名称: </span>{{formData.name}}</li>
                        <li><span class="color-info">用户身份: </span>{{$userType.get(formData.userType)}}</li>
                    </ul>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="contractSn" label="合同编号:" :rules="[{required: true, message: '请输入合同编号'}]">
                    <el-input
                        v-model.trim="formData.contractSn"
                        placeholder="请输入合同编号"
                        size="medium"
                        maxlength="100"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="contractExpireTime" label="合同到期时间:" :rules="[{required: true, message: '请输入合同到期时间'}]">
                    <el-date-picker
                        v-model="formData.contractExpireTime"
                        type="datetime"
                        start-placeholder="合同到期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="medium">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>


<script>
import {fetchUser} from '@/assets/js/commonApi';
export default {
    props:{
        formData:{
            type: Object,
            default: null
        },
        id:{
            type: [String,Number],
            default: ''
        }
    },
    data(){
        return{
            btnLoading: false,
			hostList:[], //主办方集合(临时)
			
        }
    },
    watch:{
        'formData.userId'(v1,v2){
            if(!this.id && v1 != v2){
                this.formData.name = '';
                this.formData.userType = '';
            }
        }
    },
    methods:{
        checkUserInfo(){
            if( !this.formData.userId ){
                return this.$message.warning('请输入用户ID');
            }
            this.btnLoading = true;
            this.$request({
                url: "/goods/receivables/detectUsers",
                params: { userId: this.formData.userId },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData.name = result.name;
                        this.formData.userType = result.userType;
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
		// 主办方搜索
		searchHost(query){
		    this.searchUser(query,-1,'hostList');
		},
		// 搜索用户
		async searchUser(query,userType,obj){
		    if(query !== ""){
		        this.userLoading = true;
		        const res = await fetchUser({
		            queryValue:query,
		            userType:userType,
		        }).finally(() => {
		            this.userLoading = false;
		        });
		        
		        const { state, result } = res.data;
		        
		        if (state == 1 && result) {
		            this[obj] = result;
		        }
		    }
		},
    }
}
</script>

<style lang="scss" scoped>
.user-info{
    margin: 10px 0;
    li{
        display: inline-block;
        margin: 0 30px 0 0;
    }
}
</style>